export const keyboardMode = "data-bui-keyboard";
